module.exports = __webpack_public_path__ + "images/coach-now-plus-grey@2x.8318ff78dc8400641f034e28bd13f365.png";